module.exports = __webpack_public_path__ + "media/images/sample/eyecatch-product-sample-cad3fdfea419abcae97e7be247122e2a.png";